import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import { Modal } from 'react-bootstrap';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

class SchedulesIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      modal: false,
      loaded: 0,
      data: [],
      justification: '',
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.approve = this.approve.bind(this);
    this.repprove = this.repprove.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.loadData = this.loadData.bind(this);
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData(event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/solicitacoes/pendentes', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  ActionsButtons (cell, row) {
    var botao = (
      <div>
        <button className="btn btn-sm btn-success" value={cell} onClick={this.approve}>
          <i className="fa fa-fw fa-check"></i>
        </button>
        <button onClick={this.showModal.bind(this, cell)} className="btn btn-sm btn-danger"><i className="fa fa-fw fa-close"></i></button>
      </div>
    );

    return botao;
  }

  deleteRow(id) {
    var data = this.state.data;
    data.map(function(dado, index){
      if (dado.id == id) {
        data.splice(index, 1);
      }
    });
    this.setState({data: data, modal: false, justification: ''});
  }

  approve(data) {
    var confirm = window.confirm('Tem certeza de que deseja aprovar esta solicitação?');
    if (confirm) {
      var id = data.currentTarget.value;

      var datasave = {
        id: id,
      };

      var header = this.refs.request_api.header('application/json');
      var self = this;
      this.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/solicitacao/administracao/aprovar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deleteRow(id);
          }
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  repprove(event) {
    var confirm = window.confirm('Tem certeza de que deseja reprovar esta solicitação?');
    if (confirm) {
      event.preventDefault();
      var datasave = {
        id: this.state.id,
        justification: this.state.justification,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      this.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/solicitacao/administracao/reprovar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deleteRow(self.state.id);
          }
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  showModal (value, event) {
    this.setState({ id: value, modal: true});
  }


  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">Solicitações Pendentes</h3>
      <Link to="/solicitacoes/cadastrar" className="btn btn-primary pull-right"><i className="fa fa-plus"></i> Adicionar solicitação</Link>
      <div className="clearfix"></div>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: 'Não há escalas cadastradas para este mês'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>ID</TableHeaderColumn>
        <TableHeaderColumn dataField="date" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>Data da Solicitação</TableHeaderColumn>
        <TableHeaderColumn dataField="requester" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>Usuário Solicitante</TableHeaderColumn>
        <TableHeaderColumn dataField="base_origin_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>Base Origem</TableHeaderColumn>
        <TableHeaderColumn dataField="base_destination_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>Base Destino</TableHeaderColumn>
        <TableHeaderColumn dataField="staff_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>Nome do colaborador</TableHeaderColumn>
        <TableHeaderColumn dataField="date_start_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>Data Inicial</TableHeaderColumn>
        <TableHeaderColumn dataField="date_finish_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>Data Final</TableHeaderColumn>
        <TableHeaderColumn dataField="requester_reason" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>Justificativa</TableHeaderColumn>
        <TableHeaderColumn dataField="status" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>Status</TableHeaderColumn>
        <TableHeaderColumn dataField="responsible" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>Responsável - Origem</TableHeaderColumn>
        <TableHeaderColumn dataField="responsible_date" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>Responsável - Data Resposta</TableHeaderColumn>
        <TableHeaderColumn dataField="responsible_status" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>Responsável - Resposta</TableHeaderColumn>
        <TableHeaderColumn dataField="administrative" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>Administrativo - Usuário</TableHeaderColumn>
        <TableHeaderColumn dataField="administrative_date" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>Administrativo - Data Resposta</TableHeaderColumn>
        <TableHeaderColumn dataField="administrative_status" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>Administrativo - Resposta</TableHeaderColumn>
        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='200'>Ações</TableHeaderColumn>
      </BootstrapTable>

      <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
        <Modal.Header>
          <h4 className="pull-left">Justifique sua reprovação. Será enviado um e-mail para os responsáveis das bases.</h4>
          <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false, id: null })}>
          <i className="fa fa-fw fa-close"></i></button>
          <div className="clearfix"></div>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={this.repprove}>
            <div className="form-group">
              <textarea style={{ height: 100 }} type="text" name="justification" className="form-control" value={this.state.justification} onChange={this.handleChange.bind(this, 'justification')} required />
            </div>
            <div className="form-group">
              <button type={'submit'} className="btn btn-primary btn-inline btn-block"><i className="fa fa-fw fa-save"></i> Justificar</button>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false, id: null })}>
          <i className="fa fa-fw fa-close"></i></button>
        </Modal.Footer>
      </Modal>
    </div>
  </div>
</div>
    );
  }
}

export default SchedulesIndex;



// WEBPACK FOOTER //
// ./src/Components/ScheduleTrades/ScheduleTradesPending.js